module.exports = {"id":"231352","name":"Tammy Abraham","rating":"73","photo":"./data/images/photos/3/231352.png","club":{"name":"Swansea City","logo":"./data/images/clubs/SwanseaCity.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TammyAbraham0.json
// module id = 4073
// module chunks = 0